import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import WeeklySchedule from '@/types/table/weeklySchedule';
import { FilesManageData } from '@/api/generated/filesManageController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface WeeklyScheduleData extends WeeklySchedule {
  filesManage?: FilesManageData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class weeklyScheduleDetailController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WeeklyScheduleData>>(API_CONTEXT + '/app/weeklyScheduleDetail/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<WeeklyScheduleData>(API_CONTEXT + '/app/weeklyScheduleDetail/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/weeklyScheduleDetail/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/weeklyScheduleDetail/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/weeklyScheduleDetail/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/update', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/deleteBatch', params, httpOptions);
  }
  static startOnlyFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/startOnly/flowWkcWeeklySchedule', params, httpOptions);
  }
  static startWithBusinessKeyFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/startWithBusinessKey/flowWkcWeeklySchedule', params, httpOptions);
  }
  static startAndTakeUserTaskFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/startAndTakeUserTask/flowWkcWeeklySchedule', params, httpOptions);
  }
  static startAndSaveDraftFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/startAndSaveDraft/flowWkcWeeklySchedule', params, httpOptions);
  }
  static submitUserTaskFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/submitUserTask/flowWkcWeeklySchedule', params, httpOptions);
  }
  static viewTaskBusinessDataFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/weeklyScheduleDetail/viewTaskBusinessData/flowWkcWeeklySchedule', params, httpOptions);
  }
  static viewHistoricTaskBusinessDataFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get(API_CONTEXT + '/app/weeklyScheduleDetail/viewHistoricTaskBusinessData/flowWkcWeeklySchedule', params, httpOptions);
  }
  static listWorkOrderFlowWkcWeeklySchedule(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/listWorkOrder/flowWkcWeeklySchedule', params, httpOptions);
  }

  static getUserInformation(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<WeeklyScheduleData>>(API_CONTEXT + '/app/weeklyScheduleDetail/getUserInformation', params, httpOptions);
  }

  static deleteMessage(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/dept/deleteMessage', params, httpOptions);
  }
  
  static editAfterSubmission(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/weeklyScheduleDetail/editAfterSubmission', params, httpOptions);
  }  
}
